import topic from '../topic'
export const qrclAPI = {
    getQrcls: topic.qrclTopic + '/get_qrcls',
}